
<style>
  .form-material select, .form-material input, .form-material textarea, languageSelector select {
    width: 100%;
    font-size:14px;
  }

.form-material select {
  font-size:14px;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.languageContainer {
  display:block;
  margin-bottom:10px;
}

.globalContainer {
  display:block;
  margin-bottom:10px;
  padding:12px;
}

textarea {min-height: 100px;}

</style>

<app-modal-header [headerTitle]="'Edit Display Order'"></app-modal-header>
 
 
<div class="globalContainer" *ngIf="item != null">
   
    <div class="form-group row">
 
      <div class="col-sm-12">
        <div class="form-material">
 
         
              <select [(ngModel)]="item?.LiturgyType.Id"  >
                <option *ngFor="let section of liturgyTypes" [ngValue]="section.Id">
                    {{section.Localized[0].Name}}
                </option>
              </select>

            <label for="">Liturgy Type</label>

        </div>
    </div>

    <div class="col-sm-6">
      <div class="form-material">

        <select [(ngModel)]="item.LectionaryItemType.Id" (ngModelChange)="lectionaryItemTypeValueChanged($event)"> 
          <option *ngFor="let section of lectionaryItemTypes" [ngValue]="section.Id">
            {{section.Localized[0].Name}}
        </option>
      </select>
 
          <label for="">Lectionary Item Type</label>

      </div>
  </div> 
 
  <div class="col-sm-6">
      <div class="form-material">

        <select [ngModel]="item.LectionaryItemTypeSubType?.Id" (ngModelChange)="lectionaryItemTypeSubTypeValueChanged($event)"> 
          <option *ngFor="let section of selectedLectionaryItemType?.SubTypes" [ngValue]="section.Id">
            {{section.Localized[0].Name}}
        </option>
      </select>
 
          <label for="">Sub Type</label>

      </div>
  </div> 

<div class="col-sm-6">
  <div class="form-material">
      <input matInput type="number" [(ngModel)]="item.DisplayOrder">
      <label for="">Display Order</label>
  </div>
</div>

  </div>

</div>


<div mat-dialog-actions class="float-right">
  <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
  <button mat-button (click)="save()"   class="btn btn-sm btn-outline-primary">Save</button> 
</div>
